export enum VehicleActions {
  CREATE_VEHICLE = "create_vehicle",
  UPDATE_VEHICLE = "update_vehicle",
  LIST_VEHICLES = "list_vehicles",
}